import { Button } from "@/components/ui/button";
import moment from "moment";

export function PartRepairableSummaryHandler({
  currentExport,
  dataSave,
  exportToExcel,
}) {
  if (currentExport == "part repairable") {
    const exportData = dataSave.part_details
      .map((obj) => {
        if (obj.part_type == "repairable") {
          const goodCondition = [];
          const badCondition = [];
          const inTransitQuantity = [];
          const onTicketQuantity = [];
          const totalQuantity = [];
          dataSave.part_repairables.map((part_repairable) => {
            if (part_repairable.part_detail_id == obj.id) {
              if (part_repairable.status == "good") {
                goodCondition.push(part_repairable);
              }
              if (part_repairable.status == "bad") {
                badCondition.push(part_repairable);
              }
              if (part_repairable.status != "good in use") {
                totalQuantity.push(part_repairable);
              }
              if (part_repairable.status == "good on ticket") {
                onTicketQuantity.push(part_repairable);
              }
              if (
                part_repairable.status == "good in transit" ||
                part_repairable.status == "bad in transit"
              ) {
                inTransitQuantity.push(part_repairable);
              }
            }
          });
          return {
            "Part Name": obj.name,
            "Part Number": obj.part_number,
            "Safety Stock": obj.safety_stock,
            "Good Quantity": goodCondition.length,
            "Bad Quantity": badCondition.length,
            "In Transit Quantity": inTransitQuantity.length,
            "On Ticket Quantity": onTicketQuantity.length,
            "Total Quantity": totalQuantity.length,
          };
        }
      })
      .filter((obj) => obj != undefined);
    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `part_repairable_summary_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
